// Contact details and links used across the website.
// The WhatsApp number used by the portal comes from the admin (Admission
// settings) when available; this is the fallback.

export const SITE = {
  name: "The International School",
  short: "TIS",
  tagline: "First IB World Continuum School in Pakistan",
  address:
    "Pakistan Railways Campus, DHA Link Road, Kalapul area, near Tooba (Gol) Masjid, Karachi 75500",
  uan: "111-111-847",
  uanTel: "+92111111847",
  tel: "+92 21 37130186-90",
  telHref: "+922137130186",
  phone: "0321-9228669",
  phoneTel: "+923219228669",
  whatsapp: "923219228669",
  email: "info@tis.edu.pk",
  manageBac: "https://tispk.managebac.com/login",
  mapUrl: "https://maps.google.com/?q=24.8451466,67.0510606",
  socials: {
    instagram: "https://www.instagram.com/tisedupk/",
    facebook: "https://www.facebook.com/TISKHI",
    linkedin: "https://www.linkedin.com/company/the-international-school_2/",
  },
};

export function whatsappLink(text = "", number = SITE.whatsapp) {
  const digits = String(number || SITE.whatsapp).replace(/\D/g, "");
  return `https://wa.me/${digits}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
}

/** Dates like "2014-03-02" are calendar dates: read them in local time, not UTC. */
export function parseDate(value) {
  if (!value) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  const d = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatDate(value, opts = { day: "numeric", month: "short", year: "numeric" }) {
  if (!value) return "";
  const d = parseDate(value) || new Date(NaN);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-GB", opts);
}

export function formatDateTime(value) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("en-GB", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

/** Age in whole years on 1st August of the current academic year (how TIS places children). */
export function ageOnFirstAugust(dob, today = new Date()) {
  const birth = parseDate(dob);
  if (!birth) return null;
  const cutoff = new Date(today.getFullYear(), 7, 1);
  let age = cutoff.getFullYear() - birth.getFullYear();
  if (cutoff.getMonth() < birth.getMonth() || (cutoff.getMonth() === birth.getMonth() && cutoff.getDate() < birth.getDate())) {
    age -= 1;
  }
  return age;
}

export const cn = (...classes) => classes.filter(Boolean).join(" ");
